import React, { useCallback } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Col, Row } from "antd";

import StateIcon from "../../app/generic/stateIcon";
import LoadTable from "../../app/generic/loadTable";
import WorkerInfo from "../../app/generic/workerInfo";
import { deleteEntity } from "../../../modules/crudOperations";
import TableRowActions from "../../app/generic/tableRowActions";
import { parseDateTime } from "../../../modules/consignmentFunctions";

function NotificationListTable({ push, notifications, loadNotifications }) {
  const handleEditNotification = useCallback(
    (c) => {
      push(`/notification/${c.key}/edit`);
    },
    [push]
  );

  const intl = useIntl();
  const dropNotification = useCallback(
    (notificationId) => {
      deleteEntity(
        "notification",
        notificationId,
        intl.formatMessage({
          id: "notification.name.def",
          defaultMessage: "Notifikace",
        }),
        intl.formatMessage({
          id: "notification.errorName",
          defaultMessage: "notifikace",
        }),
        loadNotifications,
        true
      );
    },
    [intl, loadNotifications]
  );

  const columns = [
    {
      key: "name",
      title: intl.formatMessage({
        id: "notification.name",
        defaultMessage: "Název notifikace",
      }),
      dataIndex: "name",
      sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : -1),
    },
    {
      key: "displayToUsers",
      title: intl.formatMessage({
        id: "notification.displayToUsers",
        defaultMessage: "Zobrazeno uživatelům",
      }),
      dataIndex: "displayToUsers",
      render: (displayToUsers, { validTo }) => (
        <Row gutter={10}>
          <Col span={4}>
            <StateIcon
              valid={displayToUsers}
              messages={[
                displayToUsers
                  ? intl.formatMessage({
                      id: "notification.displayToUsers.yes",
                      defaultMessage: "Zobrazuje se uživatelům",
                    })
                  : intl.formatMessage({
                      id: "notification.displayToUsers.no",
                      defaultMessage: "Skryto před uživateli",
                    }),
              ]}
            />
          </Col>
          <Col>
            {validTo
              ? intl.formatMessage(
                  {
                    id: "notification.validTo.to",
                    defaultMessage: " do {date}",
                  },
                  { date: parseDateTime(validTo) }
                )
              : ""}
          </Col>
        </Row>
      ),
      sorter: (a, b) =>
        a.displayToUsers?.localeCompare(b.displayToUsers) ?? false,
    },
    {
      key: "insertionDateTime",
      title: intl.formatMessage({
        id: "notification.insertionDateTime",
        defaultMessage: "Datum vytvoření",
      }),
      dataIndex: "insertionDateTime",
      sorter: (a, b) =>
        a.insertionDateTime
          ? a.insertionDateTime.localeCompare(b.insertionDateTime)
          : -1,
    },
    {
      key: "creator",
      title: intl.formatMessage({
        id: "notification.creator",
        defaultMessage: "Tvůrce notifikace",
      }),
      dataIndex: "creator",
      sorter: (a, b) =>
        a.creator && a.creator.username
          ? b.creator && b.creator.username
            ? a.creator.username.localeCompare(b.creator.username)
            : 1
          : -1,
      render: (user) => <WorkerInfo user={user} />,
    },
    {
      key: "changeDateTime",
      title: intl.formatMessage({
        id: "notification.changeDateTime",
        defaultMessage: "Poslední úprava",
      }),
      dataIndex: "changeDateTime",
      sorter: (a, b) =>
        a.changeDateTime
          ? a.changeDateTime.localeCompare(b.changeDateTime)
          : -1,
    },
    {
      key: "changer",
      title: intl.formatMessage({
        id: "notification.changer",
        defaultMessage: "Úpravce notifikace",
      }),
      dataIndex: "changer",
      sorter: (a, b) =>
        a.changer && a.changer.username
          ? b.changer && b.changer.username
            ? a.changer.username.localeCompare(b.changer.username)
            : 1
          : -1,
      render: (user) => <WorkerInfo user={user} />,
    },
    {
      key: "actions",
      title: "",
      dataIndex: "",
      render: (c) => (
        <TableRowActions
          onEdit={() => handleEditNotification(c)}
          onDelete={() => dropNotification(c.key)}
        />
      ),
    },
  ];

  return (
    <LoadTable
      what={intl.formatMessage({
        id: "notification.what",
        defaultMessage: "notifikací",
      })}
      columns={columns}
      values={notifications}
      emptyText={intl.formatMessage({
        id: "notification.noNotifications",
        defaultMessage: "žádné notifikace",
      })}
      onLoadValues={loadNotifications}
      onRowDoubleClick={handleEditNotification}
    />
  );
}

export default connect(null, { push })(NotificationListTable);
